import axiosInstance from "../../api/axios";
import {setMaxYear} from "../../store/slices/filters.slice";
import {useDispatch} from "react-redux";
import {setMaxYearList} from "../../store/slices/lists.slice";
import {setMaxYearFavourites} from "../../store/slices/favouritesList.slice";

const useLatestYear = () => {
  const dispatch = useDispatch();

  const getYear = async () => {
    try {
      const result = await axiosInstance.get(`/movies/max-year`);
      dispatch(setMaxYear(result.data?.release_year || 2025));
      dispatch(setMaxYearList(result.data?.release_year || 2025));
      dispatch(setMaxYearFavourites(result.data?.release_year || 2025));
    } catch (e) {
      console.log(e, 'e');
    }
  }

  return { getYear }
}

export default useLatestYear;
